import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { Messages as a } from "@pelando/fontawesome/icons";
import { Container as c, Message as d, Link as s, ContactPelandoButton as m } from "./style.js";
import { useTranslation as f } from "../../../hooks/useTranslation/index.js";
function k({
  message: n,
  url: t,
  className: r,
  onClickContactPelando: l
}) {
  const { t: o } = f("common");
  return /* @__PURE__ */ i(c, { className: r, children: [
    /* @__PURE__ */ e(d, { children: n }),
    /* @__PURE__ */ e(s, { target: "_blank", rel: "noopener nofollow", url: t, children: o("deal-deleted-card-know-more") }),
    /* @__PURE__ */ e(
      m,
      {
        onClick: l,
        icon: a,
        iconPosition: "left",
        light: !0,
        children: o("deal-deleted-card-contact")
      }
    )
  ] });
}
export {
  k as DealDeletedCard
};
